import React, { useContext, useState } from 'react';

import { toast } from "react-toastify";

import { NavLink } from 'react-router-dom';

import Button from '../../../shared/components/FormElements/Button';

import { AuthContext } from '../../context/auth-context';
import './NavLinks.css';

const NavLinks = props => {
  const auth = useContext(AuthContext);

  // ADD THIS
  const [isSending, setIsSending] = useState(false);


  const generateOtpHandler = async () => {

    if (isSending) return;          // prevent double clicks
    setIsSending(true);

    // Show loading toast
    const toastId = toast.loading("Sending an OTP to your email....", { position: "top-center" });

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + `/users/generate-otp`,
        {
          method: "POST",

          headers: {
            Authorization: 'Bearer ' + auth.token
          },

        }

      );

      const data = await response.json();

      if (response.ok) {
        // Update to success
        toast.update(toastId, {
          render: "OTP sent successfully",
          type: "success",
          isLoading: false,
          position: "top-center",
          autoClose: 3000
        });
      } else {
        // Update to error
        toast.update(toastId, {
          render: data.message || "Failed to send OTP",
          type: "error",
          isLoading: false,
          position: "top-center",
          autoClose: 3000
        });
      }
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: "Something went wrong",
        type: "error",
        isLoading: false,
        position: "top-center",
        autoClose: 3000
      });
    } finally {
      setIsSending(false);          // always re-enable button
    }

  };

  return (
    <ul className="nav-links">
      {auth.isLoggedIn && (
        <li>
          <button className="no-border" onClick={generateOtpHandler} disabled={isSending} >{isSending ? "Generating..." : "Generate Code"}</button>  {/*Write a function upon onCLick for this to generate a 4 digit code or the user.*/}
        </li>
      )}
      {auth.isLoggedIn && (
        <li>
          <NavLink to={`/${auth.userId}/shared`}>Shared</NavLink>
        </li>
      )}
      {auth.isLoggedIn && (
        <li>
          <NavLink to={`/${auth.userId}/files`}>My Files</NavLink>
        </li>
      )}
      {auth.isLoggedIn && (
        <li>
          <NavLink to="/files/new">Files Upload</NavLink>
        </li>
      )}
      
      {!auth.isLoggedIn && (
        <li>
          <NavLink to="/" exact>Home</NavLink>
        </li>
      )}
      {!auth.isLoggedIn && (
        <li>
          <NavLink to="/entercode">Get Files</NavLink>
        </li>
      )}
      {!auth.isLoggedIn && (
        <li>
          <NavLink to="/auth" className="auth-link">Sign Up/Login</NavLink>
        </li>
      )}
      {auth.isLoggedIn && (
        <li>
          {/*<button onClick={auth.logout}>LOGOUT</button>*/}
          <Button danger onClick={auth.logout}>LOGOUT</Button>
        </li>
      )}
    </ul>
  );
};

export default NavLinks;
